// @ts-check
// Primitivas DOM seguras (03-frontend §3, §8.2). Datos externos SIEMPRE como
// texto. Prohibido innerHTML/outerHTML/insertAdjacentHTML con datos no confiables.
import { parseSafeUrl } from './safe-url.js';

/**
 * Inserta texto de forma segura, reemplazando el contenido del nodo.
 * @param {Element} element
 * @param {string} text
 */
export function setSafeText(element, text) {
  element.textContent = text;
}

/**
 * Crea un elemento con atributos y texto seguros. Nunca interpreta `text` como HTML.
 * @param {string} tagName
 * @param {{ attrs?: Record<string,string>, text?: string, className?: string }} [options]
 * @returns {HTMLElement}
 */
export function createSafeElement(tagName, options = {}) {
  const el = document.createElement(tagName);
  if (options.className) el.className = options.className;
  if (options.text !== undefined) el.textContent = options.text;
  if (options.attrs) {
    for (const [key, value] of Object.entries(options.attrs)) {
      setSafeAttribute(el, key, value);
    }
  }
  return el;
}

const URL_ATTRS = new Set(['href', 'src', 'action', 'formaction']);

/**
 * Asigna un atributo validando protocolos cuando el atributo es una URL
 * (href/src/action/formaction). Rechaza silenciosamente valores no seguros.
 * @param {Element} element
 * @param {string} name
 * @param {string} value
 */
export function setSafeAttribute(element, name, value) {
  if (URL_ATTRS.has(name.toLowerCase())) {
    const safe = parseSafeUrl(value);
    if (!safe) return; // se descarta: protocolo no permitido (p.ej. javascript:)
    element.setAttribute(name, safe.toString());
    return;
  }
  element.setAttribute(name, value);
}

/**
 * Reemplaza los hijos de un contenedor de forma segura (sin innerHTML).
 * @param {Element} container
 * @param {Node[]} children
 */
export function replaceChildrenSafely(container, children) {
  container.replaceChildren(...children);
}
